<template>
  <div>

    <button class="p-button p-component p-button-help exportBtn" type="button" @click.prevent="exportCSV()">
      <span class="pi pi-upload p-button-icon p-button-icon-left"></span><span class="p-button-label">Export</span>
      <span class="p-ink"></span>
    </button>

      <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
    <DataTable ref="po"
               :value="accountMasterLists"
               :rowsPerPageOptions="[100,500,1000]" :paginator="true" :rows="100"
               :filters="filters"
               class="p-datatable-responsive p-datatable-gridlines"
               :selection.sync="selectedProduct1" selectionMode="single">
      <Column header="S.n">
        <template #body="slotProps">
          {{ slotProps.index + 1 }}
        </template>
      </Column>
      <Column
        header="Nature" :sortable="true"
        field="accountNatureName"
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['accountNatureName']"/>
        </template>
      </Column>
      <Column :sortable="true"  
              header="Group"
              field="accountHead.name"
              filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['accountHeadName']"/>
        </template>
      </Column>
      <Column :sortable="true"  
              header="Sub Group"
              field="accountSubHead.name"
              filterField="accountSubHeadName"
              filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['accountSubHeadName']"/>
        </template>
      </Column>
      <Column :sortable="true"   header="Name" field="name" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
        </template>
      </Column>
      <Column
        header="Short Name"
        field="shortName"
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['shortName']"/>
        </template>
      </Column>
      <Column :sortable="true"
              header="Opn Balance"
              field="openingBalance"
              filterMatchMode="contains"
              bodyStyle="text-align: right"
      >
        <template #body="slotProps">
          {{ slotProps.data.openingBalance < 0 ? slotProps.data.openingBalance * (-1) : slotProps.data.openingBalance }}
        </template>
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['openingBalance']"/>
        </template>
      </Column>

      <Column :sortable="true"
              header="Dr-Cr"
              field="openingDrCr"
              filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['openingDrCr']"/>
        </template>
      </Column>
      <Column :sortable="true"
              header="Status"
              field="status"
              filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['status']"/>
        </template>
      </Column>
      <Column header="Action"  >
        <template #body="slotProps">
          <Button icon="pi pi-pencil" class="p-button-success p-button-sm p-button p-component p-button-icon-only"
                  @click="editAccountMaster(slotProps.data)" v-if="!checkAccountType(slotProps.data)"/>
          <Button icon="pi pi-pencil" class="p-button-success p-button-sm p-button p-component p-button-icon-only"
                  @click="editAccountMaster(slotProps.data)" v-else disabled/>
          <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                  v-if="checkAccountType(slotProps.data) || !slotProps.data.isSystemOnly"
                  @click="openDialog(slotProps.data.id)"/>
          <Button icon="pi pi-trash" class="p-button-danger p-button-sm" v-else
                  @click="openDialog(slotProps.data.id)" disabled/>
        </template>
      </Column>
    </DataTable>
        </div>
       </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccountMaster"/>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'accountMasterList',
  data() {
    return {
      dialogShow: false,
      selectedProduct1: null,
      accountId: '',
      columnList: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  },
  computed: {
    accountMasterLists() {
      return this.$store.state.accountMaster.accountMasterLists
    }
  },
  mounted() {
    this.accountMasterList()
    this.columnNames()
  },
  methods: {
    async accountMasterList() {
      try {
        this.$emit('loading-started')
        await this.$store.dispatch('loadAccountMasterList')
      } catch (e) {
        // Handle error
      } finally {
        this.$emit('loading-finished')
      }
    },
    editAccountMaster(data) {
      this.$emit('editAccountMaster', data)
    },
    async deleteAccountMaster(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.accountId,
        deleteReason: value
      }
      try {
        let resp = await this.$store.dispatch('deleteAccMaster', deleteRe)
        if (resp.data.status === 'SUCCESS') {
          let message = {
            message: resp.data.message,
            messageType: 'success'
          }
          this.$emit('delete-message', message)
        } else {
          let message = {
            message: resp.data.message,
            messageType: 'error'
          }
          this.$emit('delete-message', message)
        }
      } catch (e) {
        let message = {
          message: 'Something went wrong!!',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
      }

      this.closeDialog()
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Account List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'accountList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    checkAccountType(data) {
      if (data.accountTypeName === 'Bank A/c' || data.accountTypeName === 'Customer A/c' || data.accountTypeName === 'Supplier A/c') {
        return true
      }
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// accountMasterList.vue?2055ecb6